module.exports = __webpack_public_path__ + "img/event1.9c3d46e2.png";